export const API = "https://api.theweatheragency.com/api/";
export const ImageUrl = "https://api.theweatheragency.com";
// export const API = "http://192.168.18.81:5000/api/";
// export const ImageUrl = "http://192.168.18.81:5000";
// export const API = "https://stage687.mgnventures.cloud/api/";
// export const ImageUrl = "https://stage687.mgnventures.cloud";
// export const API = "https://subinflammatory-homely-tasha.ngrok-free.dev/api/";
// export const ImageUrl = "https://subinflammatory-homely-tasha.ngrok-free.dev";
// Live URL
// export const API =
//   "https://bab-digital.design-services-online.com/bab-digital-dev/public/api/";
/** Share link base for legacy media banners (product detail route removed). */
export const DetailPageUrl =
  typeof window !== "undefined"
    ? `${window.location.origin}${window.location.pathname || "/"}#/Pricing`
    : "";
